import { render, staticRenderFns } from "./inventoryBinContentsDialog.vue?vue&type=template&id=b8a11d2e&"
import script from "./inventoryBinContentsDialog.vue?vue&type=script&lang=js&"
export * from "./inventoryBinContentsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports